<template>
  <div class="personalize__form" v-bind:class="{ active: show, 'has-no-pz': hasNoPz }">
		<a href="#" class="btn-close hidden-xs" @click="closePZ" v-if="hasNoPz">
		  <i class="ico-close"></i>
		</a>
  	<div class="personalize__form--header" v-if="hasNoPz">
  		<div>
  			<span>pz</span>
  			<span>personalize</span>
  		</div>
  		<span class="_price" v-text="priceFormat()"></span>
  	</div>
  	<h3 v-text="titleAndVendor()" v-if="hasNoPz"></h3>
  	<div class="personalize__form--body">
  		<div class="personalize__form--row" v-bind:class="{extended: activeTab == '-1'}">
  			<div class="row__header">
  				<a @click="viewPzTab('-1')">1. Select Style</a>
  			</div>
  			<div class="row__lines">
  				<ul>
  					<li v-for="(line, index) in pzData.pzlines" :key="line.id" v-if="line.style_code != 'NOPERSONAL'">
							<input type="radio" :id="line.style_code" name="pzline" :checked="lineCode == line.style_code? true: false" :value="line.style_code" @click="setLineCode" />
							<label :for="line.style_code" v-text="line.style_long_desc"></label>
  					</li>
  				</ul>
  			</div>
  		</div>

  		<div class="personalize__form--row personalize__form--row-items" v-for="(style, index) in filteredStyles" v-bind:class="{extended: activeTab == index}">
  			<div class="row__header">
  				<a @click="viewPzTab(index)" v-text="tabHeaderText(style, index)"></a>
  			</div>
  			<div class="row__lines">
  				<ul v-if="style.choice_type == ''">
  					<div v-if="style.instruct_text" class="instruction" v-text="style.instruct_text"></div>
  					<li>
							<input type="text" v-bind:class="{upper: style.line_case == 'UPPER'}" :id="style.line_type" :name="style.line_type" :maxlength="style.line_max_char" :minlength="style.line_req_char" @input="changeTxt" />
							<span v-text="style.line_max_char"></span>
							<p></p>
  					</li>
  				</ul>
  				<ul v-else class="choice--block">
  					<li v-for="(choice, indexChoice) in orderedChoices" :key="indexChoice" v-if="choice.choice_type == style.choice_type">
              <input type="radio" :id="choice.choice_code" :name="style.line_type" :value="choice.choice_code" @click="setChoiceVal" />
              <label :for="choice.choice_code" v-text="choice.choice_desc"></label>
            </li>
  				</ul>
  			</div>
  		</div>
  	</div>
  	<button type="button" class="btn btn--mobile-large btn--block pz--save" :disabled="completed ? false : true" @click="previewPZ">{{savePreviewBtn}}</button>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex'

const {
	product
} = Shopify;

export default {
  name: 'personalizer',
  props: ['sku', 'show'],
  data() {
    return {
    	product: product,
    	activeTab: '-1',
    	stylesModel: [],
      price: '',
      hasNoPz: false,
      savePreviewBtn: 'save & preview',
      previewable: true
    }
  },
  mounted() {
    let _this = this;
    axios.get('https://lenox-app.herokuapp.com/api/v1/products/pz/' + this.sku)
      .then(response => {
        _this.setPzData(response.data);

        let line_code = response.data.pzlines[0].style_code;
        let style_long_desc = response.data.pzlines[0].style_long_desc;
        if(line_code == 'NOPERSONAL') {
          line_code = response.data.pzlines[1].style_code;
          style_long_desc = response.data.pzlines[1].style_long_desc;
        }
        let price = response.data.pzlines[0].style_previous_upcharge.replace("\n", "");
        if (price = '.00') {
          price = '0.00';
        }

        let pzDataForm = [];
        response.data.pzlines.map(function (line) {
          if(line.style_code == 'NOPERSONAL') {
            _this.hasNoPz = true;
          }

          if(line.style_code == line_code) {
            if(line.style_preview_status == 'I') {
              _this.savePreviewBtn = 'save';
              _this.previewable = false;
            }
          }
        });

        response.data.pzstyles.map(function (style) {
          if(style.style_code == line_code) {
            let item = {};
            let _keys = Object.keys(style);
            _keys.forEach(function (_key) {
              item[_key] = style[_key];
            });
            item['style_desc'] = style_long_desc;
            item['price'] = price;
            item['value'] = '';
            pzDataForm.push(item);
          }
        });
        
        _this.price = price;
        _this.setPzFormData(pzDataForm);

        response.data.pzstyles.map(function (style) {
          if(style.style_code == 'NOPERSONAL') {
            let item = {};
            let _keys = Object.keys(style);
            _keys.forEach(function (_key) {
              item[_key] = style[_key];
            });
            window.PZ_NOSELECTION = item;
          }
        });

        _this.$emit("priceStatus", _this.price);
      })
      .catch(e => {
        // this.errors.push(e)
        console.log(e)
      });
  },
  computed: {
    ...mapState([
      'pzData',
      'pzFormData',
      'initLineCode'
    ]),
    lineCode() {
    	return this.initLineCode;
    },
		filteredStyles: function() {
			let lineCode = this.lineCode;
			let result = [];
			if(typeof this.pzData.pzstyles != 'undefined') {
				result = this.pzData.pzstyles.filter(function(el) { return el.style_code == lineCode; });
			}
			return result
		},
    orderedChoices: function() {
      return this.pzData.pzchoices.sort(function(a, b) {
        return a.choice_display_seq - b.choice_display_seq;
      });
    },
    completed: function() {
      let result = true;

      if(this.pzFormData.length > 0) {
        this.pzFormData.forEach(function (item) {
          if(item.value == '') {
            result = false;
          }
        });

        return result;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPzData',
      'setInitLineCode',
      'setPzFormData'
    ]),
    priceFormat(){
      return '+$' + this.price;
    },
    titleAndVendor() {
    	return this.product.title + ' by ' + this.product.vendor;
    },
    viewPzTab(val) {
    	this.activeTab = val;
    },
    tabHeaderText(style, index) {
    	let _index = parseInt(index) + 2;
    	return _index + '. ' + style.line_desc;
    },
    modelPzStyle(index) {
    	return 'pzstyle' + index;
    },
    setLineCode(e) {
      let style_code = e.target.value;
    	this.setInitLineCode(style_code);

      let pzDataForm = [];

      let price = 0,
          style_long_desc = '',
          _this = this;
      this.pzData.pzlines.forEach(function (item) {
        if(item.style_code == style_code) {
          price = item.style_previous_upcharge.replace("\n", "");
          if (price = '.00') {
            price = '0.00';
          }
          style_long_desc = item.style_long_desc;

          if(item.style_preview_status == 'I') {
            _this.savePreviewBtn = 'save';
            _this.previewable = false;
          } else {
            _this.savePreviewBtn = 'save & preview';
            _this.previewable = true;
          }
        }
      });

      this.pzData.pzstyles.map(function (style) {
        if(style.style_code == style_code) {
          let item = {};
          let _keys = Object.keys(style);
          _keys.forEach(function (_key) {
            item[_key] = style[_key];
          });
          item['style_desc'] = style_long_desc;
          item['price'] = price;
          item['value'] = '';
          pzDataForm.push(item);
        }
      });
      this.setPzFormData(pzDataForm);

      $('.personalize__form--row-items input[type="text"]').val('');
      $('.personalize__form--row-items input[type="radio"]').prop('checked', false);

    },
    setChoiceVal(e) {
      let val = e.target.value;
      let name = e.target.name;

      let pzDataForm = this.pzFormData;
      pzDataForm.map(function (item) {
        if(item.line_type == name) {
          item.value = val;
        }
      });
      this.setPzFormData(pzDataForm);
    },
    changeTxt(e) {
      let val = e.target.value.trim();
      let name = e.target.name;
      let charMaxLength = parseInt(e.target.getAttribute('maxlength'));
      let charMinLength = parseInt(e.target.getAttribute('minlength'));

      let pzDataForm = this.pzFormData;
      pzDataForm.map(function (item) {
        if(item.line_type == name) {
          item.value = val;
        }
      });

      this.setPzFormData(pzDataForm);

      var $obj = $(e.target);
      if($obj.parents('li').find('span').length > 0) {
        let number = charMaxLength;
        number -= val.length;
        $obj.parent().find('span').text(number);
      }

      if(charMinLength > 0 && val == '') {
        if($obj.parents('li').find('p').length > 0) {
          let char_surfix = charMinLength > 1 ? 'characters': 'character';
          $obj.parent().find('p').text('Minimum ' + charMinLength + ' ' + char_surfix + ' is required');
          if(!$obj.parent().find('p').hasClass('active')) {
            $obj.parent().find('p').addClass('active');
          }
        }
      } else {
        if($obj.parents('li').find('p').length > 0) {
          $obj.parent().find('p').text('').removeClass('active');
        }
      }
    },
    closePZ(e) {
      $('.section-product .section__content').removeClass('pz-show');
      this.$emit("modalStatus", false);
      this.$emit("modalClose", true);
    },
    previewPZ(e) {
      $('.section-product .section__content').removeClass('pz-show');
      this.$emit("modalStatus", false);
      this.$emit("personalizedStatus", true, this.previewable);
    }
  }
}
</script>


// WEBPACK FOOTER //
// ../assets/js/personalize/components/pz-form.vue